import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import cn from 'classnames';
import { Bulb, CloseCross, Danger, ExclamationMark } from '../../icons';
import { useDevice } from '../../providers/Device';
import { useIsInBottomSheet } from '../../providers/IsInBottomSheetProvider';
import { FullRow } from '../Layout';
import { Typography } from '../Typography';
import styles from './Callout.module.scss';
const IsInCalloutContext = /*#__PURE__*/ React.createContext(false);
export const useIsInCallout = ()=>useContext(IsInCalloutContext);
const intentIcons = {
    info: Bulb,
    warning: ExclamationMark,
    error: Danger
};
export const intentIconTestIdSuffix = {
    info: 'icon-bulb',
    warning: 'icon-exclamation-mark',
    error: 'icon-danger'
};
export function Callout(props) {
    const { intent = 'info', skin = 'standard', icon, footer, withAction, className, children, weight, variant, hideIcon, withBorder: _withBorder, onDismiss, testId, classes, isMobile } = props, rest = _object_without_properties(props, [
        "intent",
        "skin",
        "icon",
        "footer",
        "withAction",
        "className",
        "children",
        "weight",
        "variant",
        "hideIcon",
        "withBorder",
        "onDismiss",
        "testId",
        "classes",
        "isMobile"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const effectiveIsMobileDevice = isMobile !== null && isMobile !== void 0 ? isMobile : isMobileDevice || isInBottomSheet;
    const shouldHideIcon = hideIcon !== null && hideIcon !== void 0 ? hideIcon : effectiveIsMobileDevice;
    const isTransparent = skin === 'transparent' && !effectiveIsMobileDevice;
    const dismissIconSize = effectiveIsMobileDevice ? 16 : 24;
    const IntentIcon = intentIcons[intent];
    return /*#__PURE__*/ _jsx(IsInCalloutContext.Provider, {
        value: true,
        children: /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
            className: cn(styles.root, styles[intent], {
                [styles.mobile]: effectiveIsMobileDevice,
                [styles.transparent]: isTransparent
            }, classes === null || classes === void 0 ? void 0 : classes.wrapper, className),
            "data-testid": testId,
            "data-mobile": effectiveIsMobileDevice ? 'true' : undefined,
            "data-transparent": isTransparent ? 'true' : undefined
        }, rest), {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.main, classes === null || classes === void 0 ? void 0 : classes.main),
                    children: [
                        !shouldHideIcon && /*#__PURE__*/ _jsx("div", {
                            className: styles.icon,
                            children: icon || /*#__PURE__*/ _jsx(IntentIcon, {
                                size: 24,
                                testId: testId ? "".concat(testId, "-").concat(intentIconTestIdSuffix[intent]) : undefined
                            })
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            className: styles.content,
                            weight: weight,
                            variant: variant,
                            children: children
                        }),
                        !effectiveIsMobileDevice && withAction,
                        onDismiss && /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: styles.dismiss,
                            onClick: onDismiss,
                            "data-testid": testId ? "".concat(testId, "-dismiss") : undefined,
                            "aria-label": "Dismiss",
                            children: /*#__PURE__*/ _jsx(CloseCross, {
                                size: dismissIconSize
                            })
                        })
                    ]
                }),
                effectiveIsMobileDevice && withAction && /*#__PURE__*/ _jsx(FullRow, {
                    gap: 8,
                    alignItems: "center",
                    className: cn(styles.actionRow, {
                        [styles.withIcon]: !shouldHideIcon
                    }),
                    children: withAction
                }),
                footer && /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.footer, classes === null || classes === void 0 ? void 0 : classes.footer),
                    children: footer
                })
            ]
        }))
    });
}
